import { render, staticRenderFns } from "./BloodSugarCard.vue?vue&type=template&id=1039e282&scoped=true&"
import script from "./BloodSugarCard.vue?vue&type=script&lang=js&"
export * from "./BloodSugarCard.vue?vue&type=script&lang=js&"
import style0 from "./BloodSugarCard.vue?vue&type=style&index=0&id=1039e282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039e282",
  null
  
)

export default component.exports